<script setup>
import {ref, computed, watch} from 'vue'
import {getTypeOptions} from "@/utils/filter"
import {useOdpCourseDatesMenusStore} from '@/stores/odpCourseDatesMenus'
import {useViewStore} from '@/stores/view'

const props = defineProps({
    viewId: String
})

// Dynamic View Store & Pinia Store
const viewStore = useViewStore(props.viewId)
const odpCourseDatesMenusStore = useOdpCourseDatesMenusStore()

// State
const options = ref(undefined)

// Computed Properties
const filters = computed(() => {
    return viewStore.filters || []
})

const filter = computed(() => {
    return filters.value.find(o => o.columnName === 'schoolId')
})

const filterKey = computed(() => {
    return filters.value.map(o => o.columnName).indexOf('schoolId')
})

const showArchive = computed(() => {
    return viewStore.showArchive
})

// Writable Computed for v-model
const schoolId = computed({
    get() {
        return parseInt(filter.value?.value) || ''
    },
    set(newSchoolId) {
        // If there is no active filter which filters by schoolId, then add it.
        if (filterKey.value === -1) {
            const type = 'relationshipOneToMany'
            const option = getTypeOptions(type)[0]

            viewStore.addFilter({
                columnName: 'schoolId',
                type: type,
                condition: option.condition,
                predicate: option.predicate,
                conditionText: option.text
            })
        }

        viewStore.setFilterProp({
            key: filterKey.value,
            name: 'value',
            value: newSchoolId
        })
    }
})

// Watchers
watch(showArchive, async () => {
    await odpCourseDatesMenusStore.fetchSchools(viewStore)
    options.value = odpCourseDatesMenusStore.getSchools(showArchive.value)
}, {immediate: true})
</script>

<template>
    <select v-if="options" v-model="schoolId" class="form-select form-select-sm w-auto">
        <option v-for="option in options" :key="option.value" :value="option.value">
            {{ option.text }}
        </option>
    </select>
</template>